/**
 * Service worker registration (Tier 4.2)
 * Only registers in production builds — offline mode in development adds noise.
 */

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] Registered, scope:', registration.scope);

        // Check for updates when the page regains focus
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) registration.update();
        });
      })
      .catch((err) => {
        console.error('[SW] Registration failed:', err);
      });

    // Trigger queue sync when the browser comes back online
    window.addEventListener('online', () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SYNC_QUEUE' });
      }
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch((err) => console.error(err));
  }
}
